/* global Libs */

Libs.Php = {
    strtr: function (str, from, to) {
        if (typeof from === "string") {
            from = from.split("");
            to = to.split("");
            if (from.length !== to.length) {
                var countFrom = from.length, countTo = to.length;
                if (countFrom > countTo) from.splice(countTo, countFrom - countTo);
                else to.splice(countFrom, countTo - countFrom);
            }
            for (var key in from) {
                while (str.indexOf(from[key]) !== -1) {
                    str = str.replace(from[key], to[key]);
                }
            }
        } else {
            for (var key in from) {
                while (str.indexOf(key) !== -1) {
                    str = str.replace(key, from[key]);
                }
            }
        }
        return str;
    }
};
